module.exports = __webpack_public_path__ + "fonts/KFOmCnqEu92Fr1Mu72xKOzY.2e0b8660.woff2";